import styled from 'styled-components';
import Slide from '../containers/Slide';
import AccentLine from '../widgets/AccentLine';
import GetEducationList from '../../data/education-list';
import { motion, useInView } from "framer-motion"
import React, { useRef } from 'react';
import SectionHeader from '../widgets/SectionHeader';
import GetGalleryList from '../../data/gallery-list';
import { globalStore } from '../../AppManager';

const Container = styled.div.attrs({ className: "gallery-slide" })`
    width: 75%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0 6rem 0;

    #gallery-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 2rem;

        h3 {
            color: var(--brand);
            font-size: 2.4rem;
            font-weight: normal;
        }

        p {
            box-sizing: border-box;
            font-size: 1.2rem;
            line-height: 1.8rem;
            color: var(--muted);
        }

        & > p {
            border-left: 4px solid var(--yellow);
            padding: 0 1rem;
        }

        #gallery {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 1rem;
            margin-top: 22px;

            .gallery-tile {
                grid-column: span 1;
                background: var(--surface);
                border: 1px solid var(--border);
                overflow: hidden;
                box-shadow: var(--shadow-soft);
                transition: transform .12s ease;
                aspect-ratio: 1 / 1;
                display: flex;
                flex-direction: column;
                cursor: pointer;

                img {
                    width: 100%;
                    height: 100%;
                    transition: 0.3s;
                }

                &:hover {
                    border-color: var(--yellow);
                }

                &:hover img {
                    width: 110%;
                    height: 110%;
                }
            }
        }
    }

    @media screen and (max-width: 980px) {
        
    }

    @media screen and (max-width: 650px) {
        #gallery-container{
            #gallery {
                grid-template-columns: 1fr 1fr;
            }
        }
    }
`

const GalleryOverlay = styled.div.attrs({ id: "gallery-overlay" })`
    display: ${({ activeImg }) => activeImg != null ? "flex" : "none"};
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    background-color: rgb(55, 55, 55, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;

    #gallery-modal {
        width: 80%;
        height: 80%;
        background: var(--muted);
        border: 1px solid var(--border);
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;

        #gallery-modal-top-toolbar {
            width: 100%;
            background: var(--white);
            border-bottom: 1px solid var(--gray);
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;

            div {
                color: var(--black);
                display: flex;
                justify-content: center;
                align-items: center;
                width: 6rem;
                height: 6rem;
                flex-shrink: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                font-size: 2rem;
                font-family: monospace;
                cursor: pointer;

                &:hover {
                    color: var(--yellow);
                }
            }
        }

        #gallery-img-wrapper {
            width: 100%;
            height: 100%;
            background-image: ${({ activeImg }) => activeImg != null ? "url(" + activeImg + ")" : null};
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
        }
    }
`

export default function GallerySlide() {

    /*
        The animation is conditional on the window's innerWidth (in coordination with the CSS media queries).
        If desktop, stagger the li's via the parent.
        If mobile, the parent stagger is discarded, and each li is responsible for its own animation.

        This was done to give that 'each item appears individually' feel.
    */

    const { activeImg, setActiveImg } = globalStore((state) => state.gallery);

    const liAnim = {
        hidden: { opacity: 0, left: '100%' },
        visible: { opacity: 1, left: '0%' }
    }

    // One ref and useInView for each education item
    const liRef1 = useRef(null);
    const liInView1 = useInView(liRef1, { once: true });

    const liRef2 = useRef(null);
    const liInView2 = useInView(liRef2, { once: true });

    const liRef3 = useRef(null);
    const liInView3 = useInView(liRef3, { once: true });

    const liRef4 = useRef(null);
    const liInView4 = useInView(liRef4, { once: true });

    const liRef5 = useRef(null);
    const liInView5 = useInView(liRef5, { once: true });

    const liRef6 = useRef(null);
    const liInView6 = useInView(liRef6, { once: true });

    const liRef7 = useRef(null);
    const liInView7 = useInView(liRef7, { once: true });

    const liRef8 = useRef(null);
    const liInView8 = useInView(liRef8, { once: true });

    const liRef9 = useRef(null);
    const liInView9 = useInView(liRef9, { once: true });

    const liRef10 = useRef(null);
    const liInView10 = useInView(liRef10, { once: true });

    const liRef11 = useRef(null);
    const liInView11 = useInView(liRef11, { once: true });

    const liRef12 = useRef(null);
    const liInView12 = useInView(liRef12, { once: true });

    const liRef13 = useRef(null);
    const liInView13 = useInView(liRef13, { once: true });

    const liRef14 = useRef(null);
    const liInView14 = useInView(liRef14, { once: true });

    const liRef15 = useRef(null);
    const liInView15 = useInView(liRef15, { once: true });

    const liRef16 = useRef(null);
    const liInView16 = useInView(liRef16, { once: true });

    const liRef17 = useRef(null);
    const liInView17 = useInView(liRef17, { once: true });

    const liRef18 = useRef(null);
    const liInView18 = useInView(liRef18, { once: true });

    const liRef19 = useRef(null);
    const liInView19 = useInView(liRef19, { once: true });

    const liRef20 = useRef(null);
    const liInView20 = useInView(liRef20, { once: true });

    const liRef21 = useRef(null);
    const liInView21 = useInView(liRef21, { once: true });

    const liRef22 = useRef(null);
    const liInView22 = useInView(liRef22, { once: true });

    const liRef23 = useRef(null);
    const liInView23 = useInView(liRef23, { once: true });

    const liRef24 = useRef(null);
    const liInView24 = useInView(liRef24, { once: true });

    const liRef25 = useRef(null);
    const liInView25 = useInView(liRef25, { once: true });

    const liRef26 = useRef(null);
    const liInView26 = useInView(liRef26, { once: true });

    const liRef27 = useRef(null);
    const liInView27 = useInView(liRef27, { once: true });

    const liRef28 = useRef(null);
    const liInView28 = useInView(liRef28, { once: true });

    const liRef29 = useRef(null);
    const liInView29 = useInView(liRef29, { once: true });

    const liRefArr = [
        { ref: liRef1, inView: liInView1 },
        { ref: liRef2, inView: liInView2 },
        { ref: liRef3, inView: liInView3 },
        { ref: liRef4, inView: liInView4 },
        { ref: liRef5, inView: liInView5 },
        { ref: liRef6, inView: liInView6 },
        { ref: liRef7, inView: liInView7 },
        { ref: liRef8, inView: liInView8 },
        { ref: liRef9, inView: liInView9 },
        { ref: liRef10, inView: liInView10 },
        { ref: liRef11, inView: liInView11 },
        { ref: liRef12, inView: liInView12 },
        { ref: liRef13, inView: liInView13 },
        { ref: liRef14, inView: liInView14 },
        { ref: liRef15, inView: liInView15 },
        { ref: liRef16, inView: liInView16 },
        { ref: liRef17, inView: liInView17 },
        { ref: liRef18, inView: liInView18 },
        { ref: liRef19, inView: liInView19 },
        { ref: liRef20, inView: liInView20 },
        { ref: liRef21, inView: liInView21 },
        { ref: liRef22, inView: liInView22 },
        { ref: liRef23, inView: liInView23 },
        { ref: liRef24, inView: liInView24 },
        { ref: liRef25, inView: liInView25 },
        { ref: liRef26, inView: liInView26 },
        { ref: liRef27, inView: liInView27 },
        { ref: liRef28, inView: liInView28 },
        { ref: liRef29, inView: liInView29 }
    ];

    // One ref and useInView for each education item
    const ulRef = useRef(null);
    const ulInView = useInView(ulRef, { once: true })

    return (
        <Slide color="var(--white);" height="auto" freeHeightBreakpoint="980px">

            <Container>

                <GalleryOverlay activeImg={activeImg}>

                    <div id='gallery-modal'>
                        <div id='gallery-modal-top-toolbar'>
                            <div onClick={() => setActiveImg(null)}> X </div>
                        </div>

                        <div id='gallery-img-wrapper'></div>
                    </div>

                </GalleryOverlay>

                <SectionHeader title="Gallery" id="gallery-section" />

                <div id='gallery-container'>

                    <h3>
                        Check out some of our past work
                    </h3>

                    <p>
                        We keep the process simple: clear scope, clean installation, and a final walkthrough so everything
                        looks right and functions perfectly.
                    </p>

                    <motion.ul id='gallery'
                        ref={ulRef}
                        animate={ulInView ? "visible" : "hidden"}
                        transition={{ delayChildren: 0.2, staggerChildren: 0.12 }}
                    >

                        {
                            GetGalleryList().map((item, index) =>
                                <motion.li
                                    className='gallery-tile'
                                    ref={liRefArr[index].ref}
                                    variants={window.innerWidth > 650 ? liAnim : null}
                                    initial={window.innerWidth < 650 ? liAnim.hidden : null}
                                    animate={window.innerWidth < 650 ?
                                        (liRefArr[index].inView ? liAnim.visible : null) : null}
                                    transition={window.innerWidth < 650 ?
                                        (liRefArr[index].inView ? { delay: 0.15, duration: 0.3 } : null) : null
                                    }
                                    onClick={() => setActiveImg(item.image)}
                                >

                                    <img src={item.image} />

                                </motion.li>
                            )
                        }

                    </motion.ul>

                </div>

            </Container>

        </Slide>
    )
}